/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Preview_FailedInputs */



/**
* | output |
* | --- |
* | "The preview could not be computed. You can still create the space." |
*
* @param {Spaces_Modular_Wizard_Preview_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_preview_failed = /** @type {((inputs?: Spaces_Modular_Wizard_Preview_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Preview_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Vorschau konnte nicht berechnet werden. Sie können den Space trotzdem anlegen.")
	return /** @type {LocalizedString} */ ("The preview could not be computed. You can still create the space.")
});